const font = {
  size: {
    $9: '9px',
    $10: '10px',
    $11: '11px',
    $12: '12px',
    $13: '13px',
    $14: '14px',
    $15: '15px',
    $16: '16px',
    $18: '18px',
    $19: '19px',
    $20: '20px',
    $22: '22px',
    $24: '24px',
    $25: '25px',
    $28: '28px',
  },
  weight: {
    demiLight: 350,
    medium: 500,
    medium2: 600,
    bold: 700,
  },
  lineHeight: {
    demiLight: '160%',
    medium: '140%',
    bold: '100%',
  },
};

const color = {
  error1: '#e10808',
  table1: '#e9eaf0',
  table2: '#f2f3f8',
  sub1: '#333333',
  sub10: '#ffffff',
};

export const moTheme = {
  font,
  color,
};

export default moTheme;
